module.exports = __webpack_public_path__ + "static/media/denegar.a51ff3fa.png";